<template>
  <div>
    <!--    <el-form-item-->
    <!--      class="custom-label__input width25"-->
    <!--      label="Danh sách cán bộ"-->
    <!--      prop="flightUserList"-->
    <!--    >-->
    <!--      <div class="flex-row flex__left">-->
    <!--        <el-button class="btnPlain" @click="addUsers">-->
    <!--          <i class="fas fa-plus-circle"></i>-->
    <!--          Thêm cán bộ-->
    <!--        </el-button>-->
    <!--      </div>-->
    <!--    </el-form-item>-->
    <div class="form-input">
      <el-table
        class="table detailRelatedDocs"
        :data="users"
        v-if="users && users.length"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-row :gutter="24">
              <hc-maybay-user-route-extend-info-item
                fieldTitle="Hộ chiếu/CMTND"
                :value="props.row.identityNumber || '-'"
              ></hc-maybay-user-route-extend-info-item>

              <hc-maybay-user-route-extend-info-item
                fieldTitle="Ngày sinh"
                :value="
                  props.row.birthday
                    | dateFormatter({
                      dateFormat: 'DD/MM/YYYY',
                      nullValue: '-'
                    })
                "
              ></hc-maybay-user-route-extend-info-item>

              <hc-maybay-user-route-extend-info-item
                fieldTitle="Giới tính"
                :value="getGenderLabel(props.row.gender)"
              ></hc-maybay-user-route-extend-info-item>

              <hc-maybay-user-route-extend-info-item
                fieldTitle="Email"
                :value="props.row.email"
              ></hc-maybay-user-route-extend-info-item>

              <hc-maybay-user-route-extend-info-item
                fieldTitle="Chức danh"
                :value="
                  getChucDanhLabel(props.row)
                "
              ></hc-maybay-user-route-extend-info-item>
            </el-row>
          </template>
        </el-table-column>

        <el-table-column width="40" type="index">
          <template #header
          >#
          </template>
        </el-table-column>

        <el-table-column
          label="Họ tên"
          show-overflow-tooltip
          property="userName"
        >
          <template slot-scope="scope">
            <el-tooltip content="Đại diện checkin" v-if="scope.row.isCheckIn">
              <i class="fas fa-check color__green"></i>
            </el-tooltip>
            <span>{{ scope.row.userName }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Số điện thoại"
          show-overflow-tooltip
          property="isdn"
          width="150px"
        >
        </el-table-column>

        <!--        <el-table-column-->
        <!--          label="Hộ chiếu/CMTND"-->
        <!--          show-overflow-tooltip-->
        <!--          property="identityNumber"-->
        <!--        >-->
        <!--        </el-table-column>-->

        <!--        <el-table-column-->
        <!--          label="Ngày sinh"-->
        <!--          show-overflow-tooltip-->
        <!--          property="birthday"-->
        <!--          align="right"-->
        <!--        >-->
        <!--          <template slot-scope="scope">-->
        <!--            <span>{{-->
        <!--              -->
        <!--            }}</span>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
      </el-table>
    </div>
  </div>
</template>

<script>
  import constants from "../../../constants";
  import hcCaseHotelUserViewService from "../../../services/khachsan/hcCaseHotelUserViewService";
  import FileTypeImage from "../../job/FileTypeImage";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import hanhChinhUtils from "../../../services/hanhChinhUtils";
  import h from "../../../services/h";
  import dateFormatter from "../../../filters/dateFormatter";
  import HcKsAddUserDialog from "./hc-ks-add-user-dialog";
  import HcMaybayUserRouteExtendInfoItem from "../vemaybay/hc-maybay-user-route-extend-info-item";

  export default {
    name: "hc-ks-users-readonly",
    mixins: [handleRequestErrorMixin],
    filters: {dateFormatter},
    components: {
      HcMaybayUserRouteExtendInfoItem,
      HcKsAddUserDialog,
      FileTypeImage
    },
    props: ["hcCaseMasterId"],

    data() {
      return {
        users: [],
        positions: null,
        departments: null,
        hcCaseHotelUserViews: null
      };
    },

    watch: {
      hcCaseMasterId() {
        this.reloadData();
      }
    },

    created() {
      this.reloadData();
    },

    methods: {

      getChucDanhLabel(user) {
        let temp_ = [];
        if (user.positionName) temp_.push(user.positionName);
        if (user.deptName) temp_.push(user.deptName);
        return temp_.join(" ")
      },

      loadHcCaseHotelUserViews() {
        return hcCaseHotelUserViewService
          .findAllByCaseMasterId(this.hcCaseMasterId)
          .then(
            response =>
              (this.users = h.collect(response.data, item => {
                return {
                  userName: item.userName,
                  gender: item.gender,
                  isdn: item.isdn,
                  email: item.email,
                  identityNumber: item.identityNumber,
                  birthday: item.birthday,
                  positionId: item.positionId,
                  deptId: item.deptId,
                  isCheckIn: item.checker === constants.TRUE,
                  positionName: item.positionName,
                  deptName: item.deptName
                };
              }))
          );
      },

      getData() {
        return this.users;
      },

      getGenderLabel(gender) {
        return hanhChinhUtils.getHcGenderLabel(gender);
      },

      reloadData() {
        this.loadHcCaseHotelUserViews();
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/khachsan/hc-ks-users-readonly.vue